// Import React
import React from "react";

// Import MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from "@mui/material/styles";

// Import Settings Context
import { useSettings } from "src/@core/hooks/useSettings";

// Import Assests
import BgImage from "src/assets/images/loginPageBgImg.png";
import WelcomeIcon from "src/@core/components/icons/WelcomeIcon";
import BeemzText from "src/@core/components/beemzText/BeemzText";
import { Typography } from "@mui/material";

const LeftWrapper = styled(Box)(({ theme }) => ({
  height: "100vh",
  display: "flex",
}));

const LeftContainer = styled(Box)(({ theme }) => ({
  flex: "1",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  backgroundImage: `url(${BgImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
}));

const RightWrapper = styled(Box)(({ theme }) => ({
  margin: "auto",
  [theme.breakpoints.up("md")]: {
    width: "70%",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  const { settings } = useSettings();

  const { skin } = settings;
  const hidden = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      {/* <ContainerWrapperMain maxWidth="xs">{children}</ContainerWrapperMain> */}
      <Grid container className="content-right" spacing={4}>
        {!hidden ? (
          <Grid item size={{ xs: 12, md: 7 }} sx={{ flex: 1 }}>
            <LeftWrapper>
              <LeftContainer>
                <WelcomeIcon />
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h4" sx={{ color: "white", mt: 2 }}>
                    <BeemzText />
                  </Typography>
                  <Typography
                    noWrap
                    variant="body1"
                    sx={{ color: "white", textTransform: "lowercase", mt: 2 }}
                  >
                    connect with trust
                  </Typography>
                </Box>
              </LeftContainer>
            </LeftWrapper>
          </Grid>
        ) : (
          <></>
        )}
        <Grid item size={{ xs: 12, sm: 12, md: 5 }}>
          <Box className="content-center">
            <RightWrapper
              sx={
                skin === "bordered" && !hidden
                  ? { borderLeft: `1px solid ${theme.palette.divider}` }
                  : {}
              }
            >
              {children}
            </RightWrapper>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AuthLayout;
